import { css } from '@emotion/css';

import { BREAKPOINT_QUERIES } from '@lyearn/core/hooks/useScreen';

export const fixedSecondaryButtonStyles = css`
  background-color: var(--interactive-white);

  :hover {
    background-color: var(--interactive-white);
  }
`;

export const avatarImage = css`
  aspect-ratio: 1;
  &.selected {
    box-shadow: 0 0 0 0.3rem black;
    .selected-icon {
      top: 0.5008rem;
      right: 0.5008rem;
    }
    .icon-backdrop {
      top: 0.8rem;
      right: 0.8rem;
    }
  }
  @media ${BREAKPOINT_QUERIES.Mobile} {
    position: relative;
    &.selected {
      .selected-icon {
        top: 0;
        right: 0;
      }
      .icon-backdrop {
        top: 0.32rem;
        right: 0.32rem;
      }
    }
  }
`;

export const actionBtnsContainer = css`
  background-image: linear-gradient(#ffffff03, white);
`;

export const drawerRoot = css`
  .MuiDrawer-paperAnchorBottom {
    border-top-left-radius: 1.2rem;
    border-top-right-radius: 1.2rem;
  }
`;

export const drawer = css`
  height: 75vh;
`;

export const w370 = css`
  width: 37rem;
`;
